// extracted by mini-css-extract-plugin
export var closeButton = "_db-1";
export var closeX = "_db-3";
export var container = "_db-0";
export var image = "_db-2";